import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@mui/material';
import { Formik } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';

import { useDispatch, useSelector } from 'react-redux';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import TrainerForm from 'src/components/trainer/TrainerForm';
import { trainersReducerAction } from 'src/redux/reducers/trainer'
import { updateTrainer, getTrainer } from 'src/api/trainer'

// setLocale({
//   mixed: {
//     notType: '${path} is required'
//   }
// });

const UpdateTrainer = () => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user ,gymId } = useSelector((state) => state.common);
  const { UpdateTrainer } = trainersReducerAction;
  const { logoutUser } = commonReducerAction;
  const { trainerList } = useSelector((state) => state.trainer);

  const [trainer, setTainer] = useState({
    name: '',
    email: '',
    mobileNumber: '',
    gender: 0,
    address: '',
    experience: null,
    remarks: '',
    profilePic: null,
    _id: '',
  });

  const location = useLocation();
  const _id = location?.pathname?.split('/')?.pop();

  useEffect(() => {
    if (trainerList?.length) {
      const trainer = trainerList.find((trainer) => trainer?._id === _id);
      if (trainer) {
        setTainer(trainer);
      }
    } else {
      dispatch(startLoading());
      getTrainer(user)
        .then((res) => {
          if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
            dispatch(logoutUser());
          if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
            dispatch(UpdateTrainer(res.data));
          }
          dispatch(stopLoading());
        })
        .catch((err) => {
          console.log(err);
          dispatch(stopLoading());
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trainerList]);

  const history = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Helmet>
        <title>Trainer | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '2rem'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              _id: trainer?._id,
              email: trainer?.email,
              name: trainer?.name,
              mobileNumber: trainer?.phone,
              gender: trainer?.gender,
              address: trainer?.address,
              experience: trainer?.experience,
              remarks: trainer?.remarks,
              profilePic: trainer?.profile_pic || ''
            }}
            enableReinitialize
            validationSchema={CONSTANTS.trainerValidationSchema}
            onSubmit={async (values) => {
              try {
                const formData = new FormData();
                formData.append('name', values.name);
                formData.append('email', values.email);
                formData.append('phone', values.mobileNumber);
                formData.append('gender', values.gender);
                formData.append('address', values.address);
                formData.append('experience', values.experience);
                formData.append('remarks', values.remarks);
                formData.append('gym_id', gymId);
                if (values.profilePic) {
                  formData.append('profile_pic', values.profilePic);
                }
                dispatch(startLoading());
                const res = await updateTrainer(user, formData , trainer?._id);
                dispatch(stopLoading());

                const isError = res.status !== 200;
                const message = isError ? res?.message : "Trainer Updated Successfully"
                setSnackbarState({
                  open: true,
                  message: message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  history(CONSTANTS.ROUTES.PRIVATE_ROUTES.TRAINER);
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <TrainerForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                heading={STRINGS.UPDATE_TRAINER}
                isFromUpdateTrainer={true}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Box>
    </>
  );
};

export default UpdateTrainer;
